import { supabase } from '@/lib/supabase'
import { deleteCookie } from '@/lib/cookies'
import { IMPERS_STASH_COOKIE, GOD_MODE_SESSION_KEY } from '../lib/storage-keys'

export async function signInWithGoogle() {
  await supabase.auth.signInWithOAuth({
    provider: 'google',
    options: { redirectTo: window.location.origin },
  })
}

/**
 * Sign out limpando o estado de impersonação e god mode.
 * `clearLocalState` é chamado pra resetar o React state do AuthContext.
 */
export async function signOutFully(clearLocalState: () => void) {
  clearLocalState()
  deleteCookie(IMPERS_STASH_COOKIE)
  try { sessionStorage.removeItem(GOD_MODE_SESSION_KEY) } catch { /* ignore */ }
  await supabase.auth.signOut()
}
